import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { T } from "../../constants/theme";

export default function SearchBar({ value, onChange }) {
  const [local, setLocal] = useState(value);

  useEffect(() => setLocal(value), [value]);

  useEffect(() => {
    const id = setTimeout(() => {
      if (local !== value) onChange(local);
    }, 400);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [local]);

  return (
    <div
      style={{
        maxWidth: 720,
        margin: "0 auto 28px",
        position: "relative",
        padding: "0 20px",
      }}
    >
      <FiSearch
        size={18}
        style={{
          position: "absolute",
          left: 38,
          top: "50%",
          transform: "translateY(-50%)",
          color: T.muted,
        }}
      />
      <input
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        placeholder="Search by name, brand or category..."
        style={{
          width: "100%",
          padding: "16px 20px 16px 46px",
          fontSize: 15,
          border: `1px solid ${T.border}`,
          borderRadius: 999,
          background: T.white,
          outline: "none",
        }}
      />
    </div>
  );
}
